/* eslint-disable i18n-scan/no-inline-content */
/* eslint-disable complexity */
import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useMessage } from '../../hooks'

const DocumentHeaders = ({ pathname }) => {
  const [title, setTitle] = useState('')
  const localizedMsg = useMessage()
  useEffect(() => {
    if (!pathname) {
      return
    }

    const titleMap = {
      '/': 'home.headerTitle',
      '/applications/sandbox': 'applications.headerTitle',
      '/applications/createbtcred': 'createbtcred.headerTitle',
      '/applications/live/create': 'applications-create-app.headerTitle',
      '/applications/braintreeCredentials/editbtcred': 'editbtcred.headerTitle',
      '/accountStatus': 'account.headerTitle',
      '/notifications': 'notifications.headerTitle',
      '/dashboard/sandbox': 'dashboard.sandbox.headerTitle',
      '/dashboard/live': 'dashboard.live.headerTitle',
      '/creditCardGenerator': 'mock.ccgenerator.headerTitle',
      '/ipnSimulator': 'ipn.ipnSimulator.title',
      '/webhooksSimulator': 'mock.whsimulator.headerTitle',
      '/webhooks/live': 'webhooksevents.live.headerTitle',
      '/webhooks/sandbox': 'webhooksevents.header.sandboxHeaderTitle',
    }

    if (titleMap[pathname]) {
      setTitle(localizedMsg(titleMap[pathname]))
      return
    }

    if (pathname.includes('/applications/edit/')) {
      setTitle(localizedMsg('applications-details-edit.headerTitle'))
      return
    }

    if (
      pathname === '/accounts' ||
      pathname === '/accounts/edit/' ||
      pathname === '/accounts/create' ||
      pathname === '/accounts/bulk' ||
      pathname === '/accounts/create/custom' ||
      pathname.includes('/accounts/duplicate/')
    ) {
      setTitle(localizedMsg('sandbox-account.headerTitle'))
      return
    }

    if (pathname.includes('/upgrade-your-apps')) {
      setTitle(localizedMsg('upgrade-hub.headerTitle'))
    }
  }, [pathname])

  return (
    <Helmet htmlAttributes={{ lang: 'en' }}>
      <title>{`${title}`}</title>
      <link
        rel="icon"
        sizes="32x32"
        href="https://www.paypalobjects.com/webstatic/developer/favicons/pp32.png"
      />
      <meta
        name="description"
        content="Developer Dashboard for apps and tools"
      />
      <meta name="keywords" content="Developer, Dashboard, apps, tools" />
    </Helmet>
  )
}

export default DocumentHeaders
